export default function slugify(slug?: string): string {
    const characterMap = new Map([
        ['ä', 'ae'],
        ['ö', 'oe'],
        ['ü', 'ue'],
        ['Ä', 'Ae'],
        ['Ö', 'Oe'],
        ['Ü', 'Ue'],
        ['ß', 'ss'],
    ])

    return (slug || '')
        .replace(/[äöüÄÖÜß]/g, char => characterMap.get(char) ?? char) // transliterate German umlauts and sharp s
        .normalize('NFD') // split an accented letter in the base letter and the accent
        .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 -]/g, '') // remove all chars not letters, numbers, spaces and hyphens (to be replaced)
        .replace(/\s+/g, '-') // separator
}
